<div class="content dark" *ngIf="assetFirmwareInfo">
	<h5>Outgoing OBCU command</h5>
	<div class="form-group row">
		<label class="col-md-4">Pending command.xml:</label>
		<div class="col-md-6 text-success" *ngIf="assetFirmwareInfo.commandFile">Present</div>
		<div class="col-md-2" *ngIf="assetFirmwareInfo.commandFile">
			<app-action-button [action]="CancelCommand" [context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure? This will rename command.xml to command.cancelled.date.xml"
				processing="...">x</app-action-button>
		</div>
		<div class="col-md-8" *ngIf="!assetFirmwareInfo.commandFile">None</div>
	</div>
	<h5>Schedule a command</h5>
	<div class="row text-white">
		<div class="col-md-2 text-center">Include</div>
		<label class="col-md-2">Target</label>
		<div class="col-md-6">Version</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectFwControl" (ngModelChange)="checkControl()" [disabled]="!enableControl" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">Control</label>
		<div class="col-md-6">{{assetFirmwareInfo.availableControl}}</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectFwWebpage" (ngModelChange)="checkControl()" [disabled]="!enableControl" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">Webpage</label>
		<div class="col-md-6">{{assetFirmwareInfo.availableWebpage}}</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectFwRegime" (ngModelChange)="checkRegime()" [disabled]="!enableRegime" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">Regime</label>
		<div class="col-md-6">{{assetFirmwareInfo.availableRegime}}</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectFwState" (ngModelChange)="checkRegime()" [disabled]="!enableRegime" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">State</label>
		<div class="col-md-6">{{assetFirmwareInfo.availableState}}</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectDescribe" (ngModelChange)="checkDescribe()" [disabled]="!enableDescribe" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">Describe</label>
		<div class="col-md-6">Perform a describe command</div>
	</div>
	<div class="row">
		<div class="col-md-2 text-center">
			<input [(ngModel)]="selectIdent" (ngModelChange)="checkIdent()" [disabled]="!enableIdent" type="checkbox" class="form-check-inline">
		</div>
		<label class="col-md-2">Update ident</label>
		<div class="col-md-6">Set the obcu ident to Fleet: <b>{{asset.fleet_name}}</b> Asset: <b>{{asset.asset_name}}</b> Asset SN: <b>{{asset.asset_serial_number}}</b></div>
	</div>
	<div class="row">
		<div class="col-md-6">
			<app-action-button [action]="CreateCommand" [context]="this" processing="Uploading..." complete="Command created">Create command.xml</app-action-button>
		</div>
	</div>
</div>